// Copyright (c) 2022 WiseTime. All rights reserved.

import { Action } from "redux"
import { Observable, of } from "rxjs"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import * as Slice from "../slice"
import { SiteId } from "../slice"
import * as Actions from "../actions"
import { grpc } from "../../../app/rpc/executor"
import { membershipClient } from "../../../app/rpc/client"
import {
  ListSitePermissionsRequest,
  ListSitePermissionsResponse,
  SitePermission
} from "../../../generated/legebill/site/membership/v4/membership_pb"

type ListSitePermissionsRpc = (siteId: SiteId) => Observable<ListSitePermissionsResponse>

export const listSitePermissions =
  (listSitePermissionsRpc: ListSitePermissionsRpc) => (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Slice.setCurrentSiteId.match),
      mergeMap(({ payload: { siteId }}) =>
        of(siteId)
          .pipe(
            mergeMap(listSitePermissionsRpc),
            map(r => ({
              siteId,
              sitePermissionsList: r.toObject().sitePermissionsList,
            })),
            map(Slice.setSitePermissions),
            catchError(_ => of(Actions.listSitePermissionsFailed()))
          )
      )
    )

const listSitePermissionsRpc = (siteId: SiteId): Observable<ListSitePermissionsResponse> =>
  grpc(() => membershipClient.listSitePermissions(
    new ListSitePermissionsRequest()
      .setSiteId(siteId)
      .setPermissionsToCheckList([
        SitePermission.MANAGE_TAGS,
        SitePermission.POST_TIME,
      ]),
    null,
  ))

export default listSitePermissions(listSitePermissionsRpc)
